import { route } from "@circle-react/lib/routes/define";

export const aiInboxRoutes = {
  list: route("/settings/inbox/ai", {
    title: "AI inbox",
    requires: "admin",
    description:
      "Browse AI inbox conversations between community members and AI agents.",
  }),

  conversation: route("/settings/inbox/ai/conversations/:id", {
    title: "AI inbox conversation",
    requires: "admin",
    description:
      "View a single AI inbox conversation thread between a community member and an AI agent.",
    pathParams: {
      id: {
        type: "number",
        description: "Numeric identifier of the AI inbox conversation.",
      },
    },
  }),
};
